import React from 'react'
import styles from './SaaS.module.css'


// import { ReactComponent as SolutionsDevelopmentIcon } from "../../../assets/SolutionsDevelopmentIcon.svg";
import { ReactComponent as Automation } from "../../../assets/AutomateGreenIcon.svg";
import { ReactComponent as ChatIcon } from "../../../assets/ChatGreenIcon.svg";
import { ReactComponent as Orchestrators } from "../../../assets/OrchestratorsIcon.svg";
import { ReactComponent as ConectionsWithAppsGreenIcon } from "../../../assets/ConectionsWithAppsGreenIcon.svg";
import { ReactComponent as PencilLinesGreen } from "../../../assets/PencilLinesGreen.svg";
import { ReactComponent as GreenFolderIcon } from "../../../assets/DocumentManagementIcon.svg";
import { ReactComponent as AssetsGreenIcon } from "../../../assets/AssetsGreenIcon.svg";
import { ReactComponent as ContactsGreenIcon } from "../../../assets/ContactsGreenIcon.svg";
import { ReactComponent as CloudSecurityGreenIcon } from "../../../assets/SecurityCloudIcon.svg";
import { ReactComponent as HelpCenter } from "../../../assets/HelpCenter.svg";
import { useTranslation } from 'react-i18next';
import HeaderCard from '../../HeaderCard/HeaderCard';
const SaaS = ({showSaas,setShowSaas,isMobile}) => {
    const [t] = useTranslation("Landing");

    const solutionsPlatform1 = [
        {
          name: t("automateTitle"),
          desc: t("automateDesc"),
          icon: <Automation />,
        },
        {
          name: t("generativeAnalysis"),
          desc: t("generativeDesc"),
          icon: <ChatIcon />,
        },
        {
          name: t("Orchestrators"),
          desc: t("gptAssistantDesc"),
          icon: <Orchestrators />,
        },
        {
          name: t("connectionsWithApps"),
          desc: t("connectionsWithAppsDesc"),
          icon: <ConectionsWithAppsGreenIcon />,
        },
     
      ];
    const solutionsPlatform2 = [
        {
          name: t("transactionsTitle"),
          desc: t("transactionsDesc"),
          icon: <PencilLinesGreen />,
        },
        {
          name: t("documentManagementTitle"),
          desc: t("documentManagementDesc"),
          icon: <GreenFolderIcon />,
        },
        {
          name: t("assetsManagement"),
          desc: t("assetsManagementDesc"),
          icon: <AssetsGreenIcon />,
        },
        {
          name: t("contactManagement"),
          desc: t("financialCRMTitle"),
          icon: <ContactsGreenIcon />,
        },

      ];
    const solutionsPlatform3 = [
        {
          name: t("cloudSecurity"),
          desc: t("cloudInfrastructureDesc"),
          icon: <CloudSecurityGreenIcon />,
        },
        {
          name: t("helpCenter"),
          desc: t("helpCenterDesc"),
          icon: <HelpCenter />,
        },
   
      ];
    

  return (
    <div className={styles.solutionsContainer} style={{
        display:showSaas && 'flex'
      }}>
      
  
      <div className={styles.container}>
      <div className={styles.content}>
        {isMobile && (
  
          <HeaderCard
          setState={setShowSaas}
          title={t('SaaS')}
          headerStyle={{
            width: "100%",
            padding: "0",
               position:"initial"
          }}
          ></HeaderCard>
        )}
    
        </div>
  


  
        <div className={styles.content}>
       
        <div className={styles.headerSolution}>
           <p>{t("smartCore")}</p>
          <span>{t("intelligenceToOptimizeOperations")}</span>
        </div>
       
          <div 
          className={`${styles.solutionsList} ${styles.bottom}`}
          onClick={() => {
            setShowSolutions(false)
            navigate('/help')
          }}
          >
            {solutionsPlatform1.map((solution, index) => (
              <div key={index} className={styles.solutionCard} >
                   <div className={styles.infoSolution}>
                  <div className={styles.icon}>{solution.icon}</div>
                  <h3>{solution.name}</h3>
                </div>
                <p>{solution.desc}</p>
              </div>
            ))}
          </div>
        </div>






        <div className={styles.content}>
       
        <div className={styles.headerSolution}>
           <p>{t("dailyOperation")}</p>
          <span>{t("organizesTeamsAndAutomateProcesses")}</span>
        </div>
       
          <div 
          className={`${styles.solutionsList} ${styles.bottom}`}
          onClick={() => {
            setShowSolutions(false)
            navigate('/help')
          }}
          >
            {solutionsPlatform2.map((solution, index) => (
              <div key={index} className={styles.solutionCard} >
                   <div className={styles.infoSolution}>
                  <div className={styles.icon}>{solution.icon}</div>
                  <h3>{solution.name}</h3>
                </div>
                <p>{solution.desc}</p>
              </div>
            ))}
          </div>
        </div>






        <div className={styles.content}>
       
        <div className={styles.headerSolution}>
           <p>{t("infrastructureAndSupport")}</p>
          <span>{t("scalableSecureAndSupported")}</span>
        </div>
       
          <div 
          className={`${styles.solutionsList} ${styles.bottom}`}
          onClick={() => {
            setShowSolutions(false)
            navigate('/help')
          }}
          >
            {solutionsPlatform3.map((solution, index) => (
              <div key={index} className={styles.solutionCard} >
                   <div className={styles.infoSolution}>
                  <div className={styles.icon}>{solution.icon}</div>
                  <h3>{solution.name}</h3>
                </div>
                <p>{solution.desc}</p>
              </div>
            ))}
          </div>
        </div>





      </div>
      </div>
  )
}

export default SaaS